import { useState, useEffect } from "react";

// A little wrapper element to cause whatever's inside to render with a tiny delay.
// From here: https://stackoverflow.com/a/61390352

type Props = {
  children: JSX.Element;
  waitBeforeShow?: number;
};

const Delayed = ({ children, waitBeforeShow = 10 }: Props) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
    return () => clearTimeout(timer);
  }, [waitBeforeShow]);

  return isShown ? children : null;
};

export default Delayed;
